import React from "react";
import { Datagrid, List, TextField, useLocaleState } from "react-admin";

const BenefitsList = () => {
  const [locale] = useLocaleState();

  return (
    <List pagination={false}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField label="benefits.title" source={`sectionTitle.${locale}`} />
      </Datagrid>
    </List>
  );
};

export default BenefitsList;
